import type { MedplumClient } from '@medplum/core';
import type { Practitioner } from '@medplum/fhirtypes';
import { editMember } from './adminActionsService';
import { isRoleMembershipOnlyUpdate, type User } from '../pages/users/types/rbac';

/** Persist a directory Practitioner profile via admin-actions edit-members. */
export async function persistDirectoryPractitionerUser(
  medplum: MedplumClient,
  userId: string,
  updates: Partial<User>,
): Promise<Practitioner | undefined> {
  if (isRoleMembershipOnlyUpdate(updates)) return undefined;
  return editMember(medplum, userId, updates);
}
